<template>
    <b-container fluid class="ds-top-body pb-5 mb-5">
        <b-row>
            <b-col cols="12">
                <!-- DS 표 규칙: 행 44 고정 — 칸마다 한 줄, 넘치면 줄이고 전체는 title(툴팁). 대체평가 행은 대체(priority) 기록을 보이고 원래 기록은 title 로 -->
                <b-table-simple hover responsive table-class="ds-table ds-table-fixed project-progress-table">
                    <b-thead>
                        <b-tr>
                            <b-th class="ds-cell-no" style="width: 56px;">No.</b-th>
                            <b-th style="width: 92px;">진행상태</b-th>
                            <b-th style="width: 100px;">캠페인</b-th>
                            <b-th>기업</b-th>
                            <b-th style="width: 84px;">평가유형</b-th>
                            <b-th v-for="stat in basic_status" :key="stat.og" style="width: 88px;">{{stat.txt}}</b-th>
                            <b-th v-if="is_admin >= 3" style="width: 88px;">기한</b-th>
                            <b-th v-if="is_admin >= 3" style="width: 128px;">개선과제</b-th>
                            <b-th v-if="is_admin >= 3">담당자 이메일</b-th>
                            <b-th v-if="is_admin >= 3" style="width: 188px;"><span class="sr-only">관리</span></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <template v-if="is_loaded_project_progress">
                            <b-tr v-if="!project_companies || !project_companies.length">
                                <b-td :colspan="table_col_count" class="text-center gray-600 py-4">참여 기업이 없습니다.</b-td>
                            </b-tr>
                            <!-- 완료 행은 글자를 흐리게 -->
                            <b-tr v-for="(company, idx) in project_companies"
                                :key="`project-${company.project_code}-priority-company-${company.id}-idx-${idx}`"
                                :class="{ 'ds-sub': progressTarget(company).status_code === 'completed' }"
                                >
                                <b-td class="ds-cell-no">{{ idx + 1 }}</b-td>

                                <b-td>
                                    <span class="ds-status" :class="`ds-status-${getProgressTone(progressTarget(company))}`">{{ getProgressStatusLabel(progressTarget(company)) }}</span>
                                </b-td>

                                <b-td>
                                    <span class="ds-ellipsis" :title="campaignTitle(company)">
                                        <span v-if="company.priority" class="ds-tag">대체</span> <template v-if="progressTarget(company).campaign_id != null">{{ progressTarget(company).campaign_id }}</template><span v-else class="ds-sub">{{ $t('미할당') }}</span>
                                    </span>
                                </b-td>

                                <b-td>
                                    <span class="ds-ellipsis" :title="companyTitle(company)">
                                        <span v-if="company.priority" class="ds-tag">대체</span> {{ progressTarget(company).company_name }} <span class="ds-sub">{{ progressTarget(company).company_id }}</span>
                                    </span>
                                </b-td>

                                <b-td>
                                    <span v-if="progressTarget(company).service_type" class="ds-tag"
                                          :class="{ 'ds-tone-danger': progressTarget(company).service_type === '심화' }"
                                          :title="company.priority ? `${company.priority.service_type} (대체 상태)` : null"
                                          >{{ progressTarget(company).service_type }}</span>
                                    <span v-else class="ds-sub">-</span>
                                </b-td>

                                <!-- 신청일 · 답변시작 · 제출일 · 배포일 — 시:분은 title -->
                                <b-td v-for="status in basic_status" :key="status.og" class="ds-cell-nowrap"
                                      :title="formatDate(progressTarget(company)[status.og], 'YY-MM-DD HH:mm')"
                                      >
                                    {{ progressTarget(company)[status.og] ? formatDate(progressTarget(company)[status.og], 'YY-MM-DD') : '-' }}
                                </b-td>

                                <!-- 기한 — 임박 · 초과는 빨간 글자. 변경은 액션 칸의 기한 변경 -->
                                <b-td v-if="is_admin >= 3" class="ds-cell-nowrap"
                                      :title="formatDate(progressTarget(company).duedate_ts, 'YY-MM-DD HH:mm')"
                                      >
                                    <span :class="{ 'ds-status ds-status-danger': isDueUrgent(company) }">{{ formatDate(progressTarget(company).duedate_ts, 'YY-MM-DD') || '-' }}</span>
                                </b-td>

                                <!-- 개선과제 — 개선계획서 전송 · 기업 제출 -->
                                <b-td v-if="is_admin >= 3" class="ds-cell-nowrap">
                                    <span v-if="progressTarget(company).manual_status === 'eco_vadis'" class="ds-sub ds-ellipsis" title="비해당 (에코바디스)">비해당 (에코바디스)</span>
                                    <span v-else-if="company.campaign_id == null" class="ds-sub ds-ellipsis" title="비해당 (미신청기업)">비해당 (미신청기업)</span>
                                    <template v-else>
                                        <span v-if="progressTarget(company).is_questionnaire_download_block" class="ds-status ds-status-secondary">외부전송</span>
                                        <span v-else class="ds-status" :class="progressTarget(company).is_actionplan_audit_sended ? 'ds-status-success' : 'ds-status-warning'">{{ progressTarget(company).is_actionplan_audit_sended ? '전송' : '미전송' }}</span>
                                        <span class="ds-sub mx-1">·</span>
                                        <span class="ds-status" :class="progressTarget(company).is_actionplan_company_sumbitted ? 'ds-status-success' : 'ds-status-warning'">{{ progressTarget(company).is_actionplan_company_sumbitted ? '제출' : '미제출' }}</span>
                                    </template>
                                </b-td>

                                <b-td v-if="is_admin >= 3">
                                    <span class="ds-ellipsis" :title="progressTarget(company).requested_e_mail">{{ progressTarget(company).requested_e_mail }}</span>
                                </b-td>

                                <!-- 행 액션(아이콘 28): 평가유형 전환 · 기한 변경 · 개선과제 · 이메일 · 커뮤니케이션. 해당 없는 것은 빈 자리로 줄 맞춤 -->
                                <b-td v-if="is_admin >= 3">
                                    <div class="d-flex justify-content-end" style="gap: 4px">
                                        <button v-if="(company.priority && company.priority.service_type) || company.service_type" type="button" class="ds-row-icon-btn"
                                                :disabled="isAssessmentTypeDisabled(company)"
                                                :aria-label="`${progressTarget(company).company_name} 평가유형 전환`" title="평가유형 전환"
                                                @click="updateServiceType(company, idx)">
                                            <b-spinner v-if="is_service_types_updating === idx" small/>
                                            <AppIcon v-else name="arrows-exchange"/>
                                        </button>
                                        <span v-else class="ds-row-icon-btn" aria-hidden="true"></span>
                                        <button v-if="is_admin == 4" type="button" class="ds-row-icon-btn"
                                                :disabled="progressTarget(company).status_code !== 'in_progress'"
                                                :aria-label="`${progressTarget(company).company_name} 기한 변경`" title="기한 변경"
                                                @click="openDueDateModal(idx)">
                                            <AppIcon name="calendar"/>
                                        </button>
                                        <span v-else class="ds-row-icon-btn" aria-hidden="true"></span>
                                        <button v-if="company.campaign_id && progressTarget(company).manual_status !== 'eco_vadis'" type="button" class="ds-row-icon-btn"
                                                :disabled="loading_actionplan_id !== null"
                                                :aria-label="`${progressTarget(company).company_name} 개선과제 관리`" title="개선과제 관리"
                                                @click="showCompanyActionplan(company)">
                                            <b-spinner v-if="loading_actionplan_id === company.company_id" small/>
                                            <AppIcon v-else name="clipboard-list"/>
                                        </button>
                                        <span v-else class="ds-row-icon-btn" aria-hidden="true"></span>
                                        <button v-if="is_admin == 4" type="button" class="ds-row-icon-btn"
                                                :aria-label="`${progressTarget(company).company_name} 이메일 전송`" title="이메일 전송"
                                                @click.stop="openEmailModal(progressTarget(company))">
                                            <AppIcon name="mail"/>
                                        </button>
                                        <span v-else class="ds-row-icon-btn" aria-hidden="true"></span>
                                        <button type="button" class="ds-row-icon-btn"
                                                :aria-label="`${progressTarget(company).company_name} 커뮤니케이션`" title="커뮤니케이션"
                                                @click.stop="openCommentModal(progressTarget(company))">
                                            <AppIcon name="message-2"/>
                                        </button>
                                    </div>
                                </b-td>
                            </b-tr>
                        </template>
                        <b-tr v-else-if="load_error">
                            <b-td :colspan="table_col_count" class="p-0">
                                <PageEmptyComponent compact :error="load_error" @retry="fetchProjectProgress" />
                            </b-td>
                        </b-tr>
                        <template v-else>
                            <b-tr v-for="n in 4" :key="`project_code-skeleton-list-${n}`">
                                <b-td v-for="c in table_col_count" :key="c"><b-skeleton></b-skeleton></b-td>
                            </b-tr>
                        </template>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="mt-3">
                <b-button v-if="is_admin === 4"
                    variant="dark-border"
                    class="ml-2"
                    :disabled="is_downloading === true"
                    @click="downloadRequestStatus"
                    >
                    <span v-if="is_downloading !== true">
                        평가 진행현황 다운로드 <fa icon="file-excel" class="ml-1"/>
                    </span>
                    <span v-else>
                        <b-spinner small></b-spinner> 파일을 준비하는 중... (최대 1분이 소요됩니다)
                    </span> 
                </b-button>
            </b-col>
        </b-row>
        <b-modal id='progress-mgt-modal' hide-footer title="이메일 보내기" size="lg">
            <div class="d-flex mt-3 pb-1">
                <div class="f-95 mr-3">제목 </div>
                <div class="w-100">
                    <b-form-radio-group v-model="mail_purpose" :options="mail_purpose_options" class="mb-2" @change="inputTitle" />
                    <b-form-input v-model="mail_title" placeholder="이메일 제목" />
                </div>
            </div>
            <div class="d-flex mt-3 pb-1">
                <div class="f-95 mr-4">To.</div>
                <div class="w-100">
                    <b-form-radio-group v-model="mail_to" :options="mail_to_options" class="mb-2" @change="inputTitle" />
                    <b-form-input v-model="to_e_mail" placeholder="수신인"  class="d-inline w-50" /> / {{ to_company_name }}
                </div>
            </div>
            
            <div class="f-95 mt-3 pb-1">내용</div>
            <b-form-textarea v-model="mail_contents" rows="12" class="mb-3" placeholder="내용 작성" />
            <div class="mb-2 text-right">
                <b-button variant="blue" class="mr-2" :disabled="is_sending_email==true" @click="sendEmail">
                    <template v-if="is_sending_email==false">
                        보내기 <fa icon="paper-plane" class="ml-2"></fa>
                    </template>
                    <template v-else>
                        <b-spinner small />
                    </template>
                </b-button>
                <b-button :disabled="is_sending_email==true" @click="$bvModal.hide('progress-mgt-modal')"> 취소 </b-button>
            </div>
        </b-modal>

        <b-modal id='comment-modal' hide-footer title="기업 커뮤니케이션 로그" size="lg">
            <comm-log :comment_company="comment_company"></comm-log>
        </b-modal>

        <b-modal id="improvement-management-modal" title="개선계획 과제 관리" size="xl"
            body-bg-variant="white"
            hide-footer
            centered
            @hidden="managing_actionplan_company = null"
            >
            <ManagingActionPlan :actionplan_company="managing_actionplan_company"
                @update-actionplan="updateActionPlan"/>
        </b-modal>

        <!-- 기한 변경 — '기한 저장'을 눌러야 저장된다. 닫기만 하면 저장하지 않는다 -->
        <b-modal id="due-date-modal" title="제출기한 변경" size="sm" hide-footer centered @hidden="onDueModalHidden">
            <template v-if="due_edit_target">
                <div>{{ due_edit_target.company_name }}</div>
                <div class="ds-sub mb-3">현재 기한 {{ formatDate(due_edit_target.duedate_ts, 'YY-MM-DD HH:mm') || '-' }}</div>
                <b-form-datepicker
                    :id="`period-extension-datepicker-${due_edit_target.company_id}`"
                    v-model="updating_dueDate[due_edit_target.company_id].duedate"
                    :title="`${due_edit_target.company_name} - 제출기한 연장일 선택`"
                    size="sm"
                    alt="기한 연장하기"
                    locale="ko-KR"
                    variant="dark-border"
                    placeholder="날짜 선택"
                    :reset-button="true"
                    :close-button="true"
                    :today-button="true"
                    :reset-value="currentDueDate(due_edit_company)"
                    label-reset-button="초기화"
                    label-close-button="설정"
                    label-today-button="오늘"
                    no-close-on-select
                    :disabled="due_edit_target.status_code !== 'in_progress' || updating_dueDate[due_edit_target.company_id].isUpdating"
                    >
                    <template v-slot:button-content>
                        <fa icon="calendar-alt" />
                    </template>
                </b-form-datepicker>
                <div class="text-right mt-3">
                    <b-btn title="기한 연장하기"
                        size="sm"
                        variant="dark-border"
                        :disabled="!isDueDateChanged(due_edit_company) || updating_dueDate[due_edit_target.company_id].isUpdating"
                        @click="saveUpdatedPeriod(
                            due_edit_target.campaign_id,
                            due_edit_target.company_id,
                            due_edit_idx, !!due_edit_company.priority, due_edit_company.company_id
                        )"
                        >
                        <fa icon="save" class="mr-1" />기한 저장
                    </b-btn>
                </div>
            </template>
        </b-modal>
        
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue';
import CommLog from '@shared_components/admin/components/managing/CommLog.vue';
import ManagingActionPlan from '@shared_components/admin/components/managing/ManagingActionPlan';
import AssessmentCommonMixin from '@shared_mixins/assessment.common.mixin.js';
import downloadFile from '@shared_mixins/downloadFile';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'ProjectProgress',
    components: {
        PageEmptyComponent,
        CommLog,
        ManagingActionPlan
    },
    mixins: [
        AssessmentCommonMixin,
        downloadFile
    ],
    data() {
        return {
            is_service_types_updating: null,
            is_loaded_project_progress: false,
            load_error: '',
            is_downloading: false,
            basic_status: [
                {og:'requested_ts', txt:'신청일'},
                {og:'in_progress_ts', txt:'답변시작'},
                {og:'in_assessment_ts', txt:'제출일'},
                {og:'completed_ts', txt:'배포일'},
            ],
            basic_types: ['일반', '심화'],
            mail_title:'',
            to_company_name: '',
            to_company_id: '',
            to_campaign_id: '',
            to_e_mail: '',
            mail_purpose: '',
            mail_purpose_options: [ {text:'보완요청', value: '보완요청'}, {text:'리마인드', value: '리마인드'}],
            mail_to: 'single',
            mail_to_options: [ {text:'담당자에게만', value: 'single'}, {text:'기업 소속 인원 전체에게', value:'all'}],
            mail_contents: '',
            is_sending_email: false,
            comment_company: null,
            updating_dueDate: {},
            // 기한 변경 모달을 연 행(project_companies 순번)
            due_edit_idx: null,
            managing_actionplan_company: null,
            loading_actionplan_id: null,
            project_companies: null
        };
    },
    computed:{
        ...mapState(['is_admin', 'user_id']),
        ...mapState('project_code',['is_project_codes_loaded','now_project']),
        ...mapState('questions',['subs', 'subs_loaded','answer_company' ] ),
        isAssessmentTypeDisabled() {
            return (company) => {
                return ((company.priority && (!!company.priority.manual_status || company.priority.status_code === 'completed')) 
                    || (company.priority && (!!company.manual_status || company.status_code === 'completed')))
                || this.is_admin <= 2;
            };
        },
        due_edit_company () {
            return this.due_edit_idx === null || !this.project_companies ? null : this.project_companies[this.due_edit_idx] || null;
        },
        due_edit_target () {
            return this.due_edit_company && this.progressTarget(this.due_edit_company);
        },
        // 머리 칸 수 — 관리자 3 이상은 기한 · 개선과제 · 이메일 · 관리 4칸이 더 있다(빈 · 오류 · 불러오는 중 행이 같은 값을 쓴다)
        table_col_count () {
            return this.is_admin >= 3 ? 13 : 9;
        }
    },
    watch: {},
    async created () {
        await this.fetchProjectProgress();
    },
    beforeDestroy () {},
    methods:{
        // silent: 표를 스켈레톤으로 바꾸지 않고 다시 읽는다(개선계획서 전송 뒤 '전송/제출' 상태 반영)
        async fetchProjectProgress (silent = false) {
            if (!silent) {
                this.is_loaded_project_progress = false;
                this.load_error = '';
            }
            try {
                const project_code = this.$route.query.pc ?? this.$route.params.project_code;
                const _res_project_progress = await this.$axios.get(`/projects/${project_code}/progress`);
                this.project_companies = this.sortingCompanies(_res_project_progress.data);

                const next_dueDate = [...this.project_companies].reduce((updatingCompanyDueDate, { company_id, duedate_ts, priority }) => {
                    updatingCompanyDueDate[priority ? priority.company_id : company_id] = {
                        duedate: !priority && duedate_ts != 'NaT'
                            ?  duedate_ts
                            : priority && priority.duedate_ts != 'NaT'
                                ? priority.duedate_ts
                                : null,
                        isUpdating: false
                    };
                    return updatingCompanyDueDate;
                }, {});
                this.updating_dueDate = silent ? {...next_dueDate, ...this.updating_dueDate} : next_dueDate;

                this.is_loaded_project_progress = true;
            } catch (error) {
                if (error?.response?.status === 401) return;
                const message = getErrorMessage(error, '진행현황을 불러오지 못했습니다.');
                if (silent) {
                    this.$EventBus.$emit('toast-failure', '진행현황 새로고침 실패', message);
                } else {
                    this.load_error = message;
                }
            }
        },
        ...mapMutations('questions',['reset_subs','update_answer_company']),
        ...mapMutations('score', ['update_temp_project_companies']),
        ...mapActions('project_code', ['progressSendEmail']),
        async updateServiceType (company, company_idx) {
            if(this.is_admin <= 2) {
                alert('평가유형 변경은 관리자만 가능합니다.');
                return;
            }
            try {
                this.is_service_types_updating = company_idx;
                let as_is_status = company.priority ? company.priority.service_type : company.service_type;
                let to_be_status = as_is_status == '일반' ? '심화' : '일반';
                let confirm_msg = company.priority ? `[대체평가, ${company.priority.project_code}]`: ''; 
                confirm_msg += `"${company.priority ? company.priority.company_name : company.company_name}"`;
                confirm_msg += `기업의 평가유형을 "${as_is_status}"에서 "${to_be_status}" 으로 변경하시겠습니까?`;

                let is_confirm_updating_service_type = await this.$showModal({
                    type: 'confirm', state: 'warning', title: '평가유형 변경', message: confirm_msg
                });
                if (is_confirm_updating_service_type) {
                    const company_id = company.priority ? company.priority.company_id : company.company_id;
                    const campaign_id = company.priority ? company.priority.campaign_id : company.campaign_id;
                    const project_code = company.priority ? company.priority.project_code : company.project_code;

                    const res_update_service_type = await this.$axios.put('/assessments/service_type', {
                        company_id, campaign_id, project_code, service_type: to_be_status
                    });

                    const _warnings = res_update_service_type.data.warnings;
                    if (_warnings && _warnings.length) {
                        alert(_warnings.join('\n'));
                    }

                    let _company_record = Object.assign({}, { ...this.project_companies[company_idx] });
                    if (company.priority) {
                        _company_record['priority']['service_type'] = res_update_service_type.data.service_type;
                    } else {
                        _company_record['service_type'] = res_update_service_type.data.service_type;  
                    }

                    this.$set(this.project_companies, company_idx, _company_record);
                }
            } catch (error) {
                if (error?.response?.status === 401) return;
                // 서버가 보낸 사유를 우선 표시, 없으면 일반 문구
                this.$EventBus.$emit('toast-failure', '평가유형 변경 실패', getErrorMessage(error, '죄송합니다. 평가유형 변경도중 장애가 발생했습니다. 개발팀에 문의주세요.'));
            } finally {
                this.is_service_types_updating = null;
            }
        },
        async showCompanyActionplan (_company) {
            if (this.loading_actionplan_id !== null) return;
            this.loading_actionplan_id = _company.company_id;
            try {
                const _res_ap = await this.$axios.get('/actionplans', {
                    params: { request_id: _company.priority ? _company.priority.request_id : _company.request_id }
                });

                let _managing_actionplan_company = _company.priority ? _company.priority : _company;
                this.managing_actionplan_company = {
                    ..._managing_actionplan_company,
                    action_plan: _res_ap.data
                };
                this.$bvModal.show('improvement-management-modal');
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '개선과제 불러오기 실패', getErrorMessage(error, '개선과제 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            } finally {
                this.loading_actionplan_id = null;
            }
        },
        updateActionPlan (_action_plan) {
            if (this.managing_actionplan_company) {
                this.$set(this.managing_actionplan_company, 'action_plan', _action_plan);
            }
            // 표의 전송/제출 표시는 진행현황 응답에서 오므로 다시 읽는다
            this.fetchProjectProgress(true);
        },
        async downloadRequestStatus () {
            try {
                this.is_downloading = true;
                const response = await this.$axios.get('/request/excel/'+ this.now_project.project_code, {
                    responseType: 'blob'
                });
                this.downloadFileFromResponse(response, `${this.now_project.project_code}_전체기업_진행현황`);
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '진행현황 다운로드 실패', getErrorMessage(error, '파일을 내려받지 못했습니다. 잠시 후 다시 시도해 주세요.'));
            } finally {
                this.is_downloading = false;
            }
        },
        // 고른 날짜가 있고 현재 기한과 날짜(앞 10자)가 다를 때만 저장할 수 있다
        isDueDateChanged (company) {
            const target = company.priority || company;
            const toDay = (value) => (value && value !== 'NaT' ? String(value).slice(0, 10) : '');
            const selected = toDay(this.updating_dueDate[target.company_id]?.duedate);
            return !!selected && selected !== toDay(target.duedate_ts);
        },
        async saveUpdatedPeriod (campaign_id, company_id, target_company_idx, is_priority) {
            try {
                this.updating_dueDate[company_id].isUpdating = true;
                let new_duedate = new Date(this.updating_dueDate[company_id].duedate);
                const _formatted_new_duedate = [
                    new_duedate.getFullYear(),
                    new_duedate.getMonth() + 1 < 10 ? `0${new_duedate.getMonth() + 1}` : new_duedate.getMonth() + 1,
                    new_duedate.getDate() < 10 ? `0${new_duedate.getDate()}` : new_duedate.getDate()
                ];
                const [
                    formatted_new_duedate,
                    confirmed_duedate
                ] = [
                    `${_formatted_new_duedate.join('-')} 18:00:00`, // 2022-09-22 18:00:00
                    `${_formatted_new_duedate[0]}년 ${_formatted_new_duedate[1]}월 ${_formatted_new_duedate[2]}일 저녁 6:00`
                ];

                const target_company = is_priority
                    ? this.project_companies[target_company_idx]['priority']
                    : this.project_companies[target_company_idx];
                const confirmed_extend_period = await this.$showModal({
                    type: 'confirm', state: 'warning', title: '제출기한 연장',
                    message: `${target_company.company_name}의 제출기한을 ${confirmed_duedate} 까지 연장하시겠습니까?`
                });
                if (!confirmed_extend_period) {
                    this.updating_dueDate[company_id] = {
                        duedate: is_priority
                            ? this.project_companies[target_company_idx]['priority']['duedate_ts']
                            : this.project_companies[target_company_idx].duedate_ts,
                        isUpdating: false
                    };
                    return false;
                }
                
                const updatingData = {
                    period: this.now_project.period,
                    company_id: company_id ,
                    campaign_id: campaign_id ,
                    new_duedate: formatted_new_duedate,
                    user_id: this.user_id
                };
                const _updated_dueDate_response = await this.$axios.get('/extend_duedate', { params: updatingData });
                const updated_new_duedate = _updated_dueDate_response.data.new_duedate;
                if (is_priority) {
                    this.project_companies[target_company_idx]['priority'].duedate_ts = updated_new_duedate;
                } else {
                    
                    this.project_companies[target_company_idx].duedate_ts = updated_new_duedate;
                }

                this.updating_dueDate[company_id]['duedate'] = updated_new_duedate;
                this.$EventBus.$emit('toast-success', '제출기한 연장 완료', `${target_company.company_name}의 제출기한이 ${confirmed_duedate} 까지 연장되었습니다.`);
            } catch (error) {
                // 401 은 인터셉터가 로그인 화면으로 보낸다
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '제출기한 연장 실패', getErrorMessage(error, '죄송합니다. 기한 연장 도중 장애가 발생해 실패했습니다. 개발팀에 문의해주세요.'));
            } finally {
                this.updating_dueDate[company_id].isUpdating = false;
            }
        },
        // getProgressStatus(company){
        //     if(company.manual_status == 'eco_vadis') return '에'
        //     else if(company.status_code == 'completed') return '완'
        //     else if(company.status_code == 'in_assessment') return '평'
        //     else if(company.status_code == 'requested') return '신'
        //     else if(company.status_code =='in_progress' && (company.in_assessment_ts=='NaT'||company.in_assessment_ts=='')) return '답'            
        //     else if(company.status_code == 'in_reprogress') return '보' 
        //     else if(company.status_code =='in_progress' && company.in_assessment_ts!='NaT') return '보'
        //     // if(company.priority && !company.status_code) return '대체'
        //     else return null
        // },
        // 대체평가 행은 대체(priority) 기록을 기준으로 보이고 다룬다
        progressTarget (company) {
            return company.priority || company;
        },
        campaignTitle (company) {
            const label = (c) => `${c.project_code} · ${c.campaign_id ?? this.$t('미할당')}`;
            return company.priority ? `대체 ${label(company.priority)} / 원래 ${label(company)}` : label(company);
        },
        companyTitle (company) {
            const label = (c) => `${c.company_name} (${c.company_id})`;
            return company.priority ? `대체 ${label(company.priority)} / 원래 ${label(company)}` : label(company);
        },
        openDueDateModal (idx) {
            this.due_edit_idx = idx;
            this.$bvModal.show('due-date-modal');
        },
        // 지금 저장된 기한(대체면 대체 쪽) — 달력의 초기값
        currentDueDate (company) {
            return company.priority && (company.priority.duedate_ts != 'NaT' || company.priority.duedate_ts)
                ? company.priority.duedate_ts
                : (company.duedate_ts != 'NaT' || company.duedate_ts) ? company.duedate_ts : null;
        },
        // 저장하지 않고 닫으면 고른 날짜를 버린다 — 다음에 열 때 지금 기한부터(저장 중이면 그대로 둔다)
        onDueModalHidden () {
            const company = this.due_edit_company;
            const target = this.due_edit_target;
            const draft = target && this.updating_dueDate[target.company_id];
            if (draft && !draft.isUpdating) draft.duedate = this.currentDueDate(company);
            this.due_edit_idx = null;
        },
        // 기한 임박 · 초과(답변 전) 또는 제출 뒤 3일 넘게 평가중
        isDueUrgent (company) {
            company = company.priority ? company.priority : company;
            let left_days = 0;
            let past_days = 0;
            let txt_duedate = null;
            let txt_past = null;
            if (this.isIE === true) {
                txt_duedate = company.duedate_ts.replace('-', '/');
                txt_past = company.in_assessment_ts.replace('-', '/');
            } else {
                txt_duedate = company.duedate_ts;
                txt_past = company.in_assessment_ts;
            }
            let due_gap = new Date(txt_duedate).getTime() - new Date().getTime();
            left_days = Math.floor(due_gap / (1000 * 60 * 60 * 24)); // 남은 일수

            let past_gap = new Date().getTime() - new Date(txt_past).getTime();
            past_days = Math.floor(past_gap / (1000 * 60 * 60 * 24)); // 지난 일수
            
            if((company.status_code=='requested'||company.status_code=='in_progress')&& left_days < 3 ) {
                return true;
            }
            return company.status_code=='in_assessment' && past_days >= 3;
        },
        badges(company){
            // console.log(company.status_code);
            if (company.status_code=='in_progress' && (company.in_assessment_ts=='NaT'||company.in_assessment_ts=='')) return 'blue-basic';
            else if (company.status_code=='in_assessment'||company.status_code=='in_reprogress') return 'red';
            else if (company.status_code=='in_progress' && company.in_assessment_ts!='NaT') return 'red';
            else if (company.status_code=='completed') return 'basic';
            else if (company.status_code=='canceled') return 'advance';
            else return 'advance';
        },
        openEmailModal(company){
            this.$bvModal.show('progress-mgt-modal');
            // 이전 기업에 쓰던 제목/내용/목적이 남아 다른 기업에 발송되지 않도록 초기화
            this.mail_purpose = '';
            this.mail_title = '';
            this.mail_contents = '';
            this.mail_to = 'single';
            this.to_company_name = company.company_name;
            this.to_campaign_id = company.campaign_id;
            this.to_company_id = company.company_id;
            this.to_e_mail = company.requested_e_mail;
        },
        openCommentModal(company){
            this.$bvModal.show('comment-modal');
            this.comment_company = company;
        },
        inputTitle(){
            if (this.mail_purpose == '보완요청'){ this.mail_title = `ESG 평가 답변 보완 요청 - ${this.to_company_name}`;}
            else if (this.mail_purpose == '리마인드'){ this.mail_title = `ESG 평가 리마인드 - ${this.to_company_name}`;}
        },
        async sendEmail () {
            if (this.formCheck()!=false){
                if (this.mail_to === 'all') {
                    const ok = await this.$showModal({
                        type: 'confirm', state: 'warning', title: '이메일 전송',
                        message: `${this.to_company_name} 소속 인원 전체에게 메일이 발송됩니다. 발송한 메일은 되돌릴 수 없습니다. 보내시겠습니까?`
                    });
                    if (!ok) return;
                }
                this.is_sending_email = true;
                try {
                    let result = await this.progressSendEmail({
                        company_id: this.to_company_id,
                        campaign_id: this.to_campaign_id,
                        e_mail: this.to_e_mail,
                        mail_to_option: this.mail_to,
                        title: this.mail_title,
                        contents: this.mail_contents
                    });
                    if(result.code!='success'){
                        this.$EventBus.$emit('toast-failure', '이메일 전송 실패', result.msg || '이메일을 보내지 못했습니다.');
                    } else {
                        this.$bvModal.hide('progress-mgt-modal');
                        this.$EventBus.$emit('toast-success', '이메일 전송 완료', result.msg);
                    }
                } catch (error) {
                    this.$EventBus.$emit('toast-failure', '이메일 전송 실패', getErrorMessage(error, '이메일을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.'));
                } finally {
                    this.is_sending_email = false;
                }
            }           
        },
        formCheck(){
            if (this.to_company_id==''||this.to_e_mail=='') { alert('이메일을 보낼 기업이 선택되지 않았습니다.'); 
                return false; }
            else if (this.mail_title=='') { alert('이메일 제목을 작성해 주세요'); 
                return false; }
            else if (this.mail_contents=='') { alert('이메일 내용을 작성해 주세요'); 
                return false; }
            else return true;            
        }
    }
};
</script>

<style>
/* 폭을 안 적은 기업 · 담당자 이메일이 각각 120 남짓 아래로 줄지 않게(고정 열 합 1088). 넓은 화면 본문 폭(1338) 안에 든다 */
.project-progress-table {
    min-width: 1336px;
}
/* .red-dot{
    position: relative;

}
.red-dot::after {
    position: absolute;
    right: 0;
    top: 10px;
    width: 6px;
    height: 6px;
    border-radius: 0.5rem;
    background-color: var(--red);
    z-index: 10;
} */
</style>
